// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__306qW","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__363G-"};